var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MeetingRequestForm from "./MeetingRequestForm";
/**
 * Meeting Request Page Component
 *
 * Displays a hero image and the meeting request form.
 * This is the main page component for the meeting request microservice.
 */
var isEmbedded = function () {
    try {
        return window.self !== window.top;
    }
    catch (_a) {
        return true;
    }
};
var MeetingRequestPage = function () {
    if (isEmbedded()) {
        return _jsx(MeetingRequestForm, {});
    }
    return (_jsx("div", __assign({ className: "container py-4" }, { children: _jsxs("div", __assign({ className: "mx-auto", style: { maxWidth: 980 } }, { children: [_jsx("div", __assign({ className: "mb-3" }, { children: _jsx("img", { src: "/images/doctor-meeting.webp", alt: "Schedule a meeting with our team", className: "img-fluid shadow-sm w-100", style: { borderRadius: 16, objectFit: 'cover', maxHeight: 435, objectPosition: 'center 40%' }, onError: function (e) { e.target.style.display = 'none'; } }) })), _jsx("div", __assign({ className: "mt-3" }, { children: _jsx(MeetingRequestForm, {}) }))] })) })));
};
export default MeetingRequestPage;
